if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
      y = direction * 100;
    if (elem.classList.contains("gs__slideIn--from-left")) {
      x = -100;
      y = 0;
    } else if (elem.classList.contains("gs__slideIn--from-right")) {
      x = 100;
      y = 0;
    }
    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";
    gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
      duration: 1.25,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: "expo",
      overwrite: "auto",
      stagger: 0.2
    });
  }

  function hide(elem) {
    gsap.set(elem, {autoAlpha: 0});
  }

  gsap.utils.toArray(".gs__slideIn").forEach(function (elem) {

    hide(elem); // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      start: "top 70%",
      end: "bottom 25%",
      //	markers: {startColor: "#b825e2", endColor: "#f31010", fontSize: "12px"},
      onEnter: function () {
        animateFrom(elem)
      },
      once: true
      //	onEnterBack: function() { animateFrom(elem, -1) },
      //onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
    });
  });
}
